<template>
  <div v-if="toast.show" class="toast-notification">
    <div :class="['toast', `toast-${toast.type}`]">
      <span class="toast-icon">{{ toast.type === 'success' ? '✓' : toast.type === 'error' ? '✗' : 'ℹ' }}</span>
      <span>{{ toast.message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToastNotification',
  props: {
    toast: {
      type: Object,
      required: true,
      default: () => ({ show: false, message: '', type: 'info', timeout: null })
    }
  }
}
</script>

<style scoped>
.toast-notification {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 10000;
  animation: slideInRight 0.3s ease;
}

.toast {
  min-width: 300px;
  padding: 14px 20px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
  background: rgba(0, 0, 0, 0.85);
  color: white;
  font-size: 14px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  gap: 12px;
}

.toast-success {
  background: linear-gradient(135deg, #059669, #047857);
}

.toast-error {
  background: linear-gradient(135deg, #dc2626, #b91c1c);
}

.toast-info {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
}

.toast-icon {
  font-size: 18px;
  font-weight: bold;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/DisputedOrders/components/ToastNotification.vue